import React, { useEffect, useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Accordion, AccordionTab } from "primereact/accordion";
import { InputSwitch } from "primereact/inputswitch";
import Filter, { EmptyFilter, IFilter } from "./Filter";
import { Dialog } from "primereact/dialog";
import ConsultantMarketingHistory from "./ConsultantMarketingHistory";

interface Iprops {
  toast: any;
  permissions: IPermissionProps;
}

export interface IConsultantListMast {
  consultant_ID: number;
  consultant_Name: string;
  consultant_Email_ID: string;
  in_PO: boolean;
  marketing_Availibility: boolean;
}

const Table = (props: Iprops) => {
  const [tableData, setTableData] = useState<{ tableData: Array<IConsultantListMast>; loading: boolean }>({ tableData: [], loading: false });
  const [filters, setFilters] = useState<IFilter>(EmptyFilter);
  const [togglingIds, setTogglingIds] = useState<number[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [historyVisible, setHistoryVisible] = useState(false);
  const [historyConsultant, setHistoryConsultant] = useState<{ id: number; name: string } | null>(null);
  const dt = useRef<any>(null);
  const [lazyParams, setLazyParams] = useState<ILazyParams>({
    first: 0,
    rows: 25,
    page: 1,
    sortField: "lead_ID",
    sortOrder: -1,
  });
  const loadTableData = async (currentFilters = filters, currentLazy = lazyParams) => {
    setTableData((prev) => ({ ...prev, loading: true }));
    const response = await Fetch("Consultant_Mast/getconsultantlist", "GET", null, `lazyParams=${JSON.stringify(currentLazy)}&filter=${JSON.stringify(currentFilters)}`, props.toast);
    if (response) {
      const data: Array<IConsultantListMast> = await response.json();
      setTableData({ tableData: data, loading: false });
    } else {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };
  const handleMarketingToggle = async (rowData: IConsultantListMast) => {
    const newValue = !rowData.marketing_Availibility;
    setTableData((prev) => ({
      ...prev,
      tableData: prev.tableData.map((row) => (row.consultant_ID === rowData.consultant_ID ? { ...row, Marketing_Availibility: newValue } : row)),
    }));

    setTogglingIds((prev) => [...prev, rowData.consultant_ID]);

    const response = await Fetch("Consultant_Mast/UpdateMarketingAvailability", "POST", { Consultant_ID: rowData.consultant_ID, Marketing_Availibility: newValue }, "", props.toast);

    if (!response) {
      setTableData((prev) => ({
        ...prev,
        tableData: prev.tableData.map((row) => (row.consultant_ID === rowData.consultant_ID ? { ...row, Marketing_Availibility: rowData.marketing_Availibility } : row)),
      }));
    }

    setTogglingIds((prev) => prev.filter((id) => id !== rowData.consultant_ID));
    if (response) {
      loadTableData();
    }
  };

  const getTableDataCount = async (currentFilters = filters) => {
    const response = await Fetch("Consultant_Mast/Consultantcount", "GET", null, `filter=${JSON.stringify(currentFilters)}`, props.toast);
    if (response) {
      const count: number = parseInt(await response.text(), 10);
      setTotalRecords(count);
    }
  };

  useEffect(() => {
    getTableDataCount();
  }, [filters]);

  useEffect(() => {
    loadTableData();
  }, [filters, lazyParams]);

  const marketingAvailabilityBody = (rowData: IConsultantListMast) => {
    const isToggling = togglingIds.indexOf(rowData.consultant_ID) !== -1;
    return <InputSwitch checked={rowData.marketing_Availibility} onChange={() => handleMarketingToggle(rowData)} disabled={isToggling} />;
  };
  const onSort = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
    loadTableData(filters, event);
  };
  const onPage = (event: any) => {
    delete event.filters;
    delete event.multiSortMeta;
    setLazyParams(event);
    loadTableData(filters, event);
  };

  const historyBody = (rowData: IConsultantListMast) => (
    <i
      className="pi pi-history"
      style={{ color: "var(--primary-color)", cursor: "pointer" }}
      onClick={() => {
        setHistoryConsultant({ id: rowData.consultant_ID, name: rowData.consultant_Name });
        setHistoryVisible(true);
      }}
    />
  );

  return (
    <>
      <Accordion>
        <AccordionTab header="Filter">
          <Filter filters={filters} setFilters={setFilters} />
        </AccordionTab>
      </Accordion>
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }}
        ref={dt}
        size="small"
        value={tableData.tableData}
        lazy
        dataKey="Consultant_ID"
        paginator
        first={lazyParams.first}
        rows={lazyParams.rows}
        totalRecords={totalRecords}
        onPage={onPage}
        onSort={onSort}
        sortField={lazyParams.sortField}
        sortOrder={lazyParams.sortOrder}
        rowsPerPageOptions={[25, 50, 100, 200]}
        showGridlines
        emptyMessage="No Users found."
        header="Consultant List"
        loading={tableData.loading}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      >
        <Column field="sn" header="SN" body={(_rowData: any, options: any) => options.rowIndex + 1} />
        <Column field="consultant_Name" header="Consultant Name" />
        <Column field="consultant_Email_ID" header="Email" />
        <Column field="in_PO" header="In Running Project" body={(rowData: IConsultantListMast) => (rowData.in_PO ? "Yes" : "No")} />
        <Column header="Marketing Availability" body={marketingAvailabilityBody} />
        <Column header="History" body={historyBody} />
      </DataTable>
      <ConsultantMarketingHistory visible={historyVisible} consultantId={historyConsultant?.id ?? null} consultantName={historyConsultant?.name ?? ""} toast={props.toast} onHide={() => setHistoryVisible(false)} />
    </>
  );
};

export default Table;
